import React, { useState } from 'react';
import WorkPlatform from './components/WorkPlatform';
import LandingPage from './components/LandingPage';

function App() {
  const [showApp, setShowApp] = useState(false);

  return (
    <>
      {showApp ? <WorkPlatform /> : <LandingPage onGetStarted={() => setShowApp(true)} />}
    </>
  );
}

export default App;